module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shouldShow) ? _c('ul', {
    staticClass: "block-list no-bullet"
  }, _vm._l((_vm.linkItems), function(linkItem) {
    return _c('li', [_c('a', {
      attrs: {
        "href": linkItem.Href
      }
    }, [_vm._v(_vm._s(linkItem.Name))])])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f40e629"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top/TopTextBoxLinkList.vue
// module id = 98
// module chunks = 1